import api, { Pagination } from '..'
export class LogService {
  static async findAll(pagination: Pagination) {
    const response = await api.get(
      `/logs?sort=-createdAt&page=${pagination.page}&perPage=${pagination.perPage}`
    )
    const { count, result } = response.data
    return {
      count,
      result: result.map((it: any) => ({
        ...it,
        text: it.description || it.action,
        causer: {
          ...it.causer,
          fullname: `${it.causer.lastname || ''} ${it.causer.firstname || ''}`
        }
      }))
    }
  }
}
